import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
} from "@mui/material";
import { STAFF_ROLES } from "../types/eventTypes";

const StaffAssignForm = ({ onSubmit, onCancel, loading }) => {
  const [form, setForm] = useState({
    userId: "",
    employeeId: "",
    name: "",
    role: "photographer",
    phone: "",
    salary: "",
    reportingTime: "",
    releaseTime: "",
    notes: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...form,
      salary: Number(form.salary) || 0,
      assigned: true,
      attendance: false,
      status: "assigned",
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Staff Name *"
            fullWidth
            required
            disabled={loading}
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Role</InputLabel>
            <Select
              value={form.role}
              label="Role"
              disabled={loading}
              onChange={(e) => setForm({ ...form, role: e.target.value })}
            >
              {STAFF_ROLES.map((r) => (
                <MenuItem key={r.value} value={r.value}>
                  {r.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Phone"
            fullWidth
            disabled={loading}
            value={form.phone}
            onChange={(e) => setForm({ ...form, phone: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Salary (₹)"
            type="number"
            fullWidth
            disabled={loading}
            value={form.salary}
            onChange={(e) => setForm({ ...form, salary: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Reporting Time"
            fullWidth
            disabled={loading}
            placeholder="05:00 AM"
            value={form.reportingTime}
            onChange={(e) =>
              setForm({ ...form, reportingTime: e.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Release Time"
            fullWidth
            disabled={loading}
            placeholder="10:00 PM"
            value={form.releaseTime}
            onChange={(e) => setForm({ ...form, releaseTime: e.target.value })}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Notes"
            fullWidth
            multiline
            rows={2}
            disabled={loading}
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
        <Button type="submit" variant="contained" fullWidth disabled={loading}>
          Assign Staff
        </Button>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
      </Box>
    </form>
  );
};

export default StaffAssignForm;
